import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Alert } from "@mui/material";

import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import { toggleModal } from "app/store/transmission/slice/transmissionSlice";
import { isReportSigned } from "utils/footerView.util";

const PhysicianUnprocessModal = ({ onConfirm }) => {
  const dispatch = useDispatch();

  const {
    reportDetail,
    isReportUnProcessing,
    isPhysicianUnprocessFromClinicProcessedModal,
  } = useSelector((state) => state.transmission);

  // Remount on each open so the dialog starts fresh
  if (!isPhysicianUnprocessFromClinicProcessedModal) return null;

  return (
    <ConfirmModal
      confirmText="Confirm"
      title="Do you want to unprocess this report?"
      isConfirming={isReportUnProcessing}
      onConfirm={onConfirm}
      onCancel={() =>
        dispatch(
          toggleModal({
            type: "physicianUnprocessFromClinicProcessed",
            value: false,
          })
        )
      }
    >
      <div className="d-flex flex-column">
        {isReportSigned(reportDetail) && (
          <Alert severity="warning" className="mt-2">
            The signature will be permanently removed once this report is
            unprocessed and cannot be restored.
          </Alert>
        )}
      </div>
    </ConfirmModal>
  );
};

export default PhysicianUnprocessModal;
